
export interface TokenExchangeRequestDTO {
    appId: string;
    parentAppToken: string | null;
}

export interface TokenExchangeResponseDTO {
    accessToken: string;
}

export interface InternationalStringDTO {
    en: string;
    my: string;
}

export interface OperatorDTO {
    id: string;
    code: string;
    name: InternationalStringDTO;
    logoUrl: string;
}

export interface SourceLocationDTO {
    id: string;
    name: InternationalStringDTO;
    destinations: LocationDTO[];
}

export interface LocationDTO {
    id: string;
    name: InternationalStringDTO;
}
export interface ArticleDTO {
    title: IntlStringDTO,
    body: IntlStringDTO
}
interface IntlStringDTO {
    en: string;
    my: string;
}
export interface MasterDataDTO {
    //operators: OperatorDTO[];
    sources: SourceLocationDTO[];
    shuttleSources: SourceLocationDTO[];
}

export interface MoneyDTO {
    currency: string,
    amount: number
}

export interface PriceRangeDTO {
    min: MoneyDTO;
    max: MoneyDTO;
}

export type GenderType = "MALE_ONLY" | "FEMALE_ONLY" | "MIXED"

export interface TripResultDTO {
    id: string;
    operator: OperatorDTO;
    fullRouteName: InternationalStringDTO;
    busType: InternationalStringDTO;
    busNumber?: string;
    isDepartingFromOrigin: boolean;
    origin: WayPointScheduleDTO;
    departure: WayPointScheduleDTO;
    arrival: WayPointScheduleDTO;
    isForForeigner: boolean;
    priceRange: PriceRangeDTO;
    isSeatSelectionAllowed: boolean;
    isSmallCar: boolean;
    isDirectBookable: boolean;
    hasPickUpService: boolean;
    hasDropOffService: boolean;
    notices: InternationalStringDTO[];
    highlights: InternationalStringDTO[];
}

export interface TripSearchCriteria {
    sourceId: string;
    destinationId: string;
    departureDate: string;
    numberOfSeats: number;
    isForForeigner: boolean;
}

export interface TripResultAggregateDTO {
    criteria: TripSearchCriteria;
    data: TripResultDTO[];
}

export interface TripDTO extends TripResultDTO {
    seatPlan?: SeatPlanDTO;
    pickUpServiceOptions?: PickUpServiceOptionDTO[];
    dropOffServiceOptions?: DropOffServiceOptionDTO[];
}

export interface SeatPlanCellDTO {
    isSeat: boolean;
    seat?: SeatDTO
}

export interface PriceLevel {
    value: number,
    max: number
}

export interface SeatDTO {
    id: string;
    number: string;
    isAvailable: boolean;
    hash: string;
    price: MoneyDTO,
    priceLevel: PriceLevel
}


export interface SeatPlanDTO {
    grid: SeatPlanCellDTO[][];
}

export interface SeatSelectionDTO {
    id: string;

    number: string;

    price: MoneyDTO;

    hash: string;
}

export interface TravellerDTO {
    name: string;
    email?: string;
    phoneNumber: string;
    gender: GenderType;
    specialRequest: string;
}

/**
 * Represents the price of a seat in a booking.
 */

export interface SeatOrderRequestDTO {
    numberOfSeats: number;
    seatSelections: SeatSelectionDTO[];
}

export interface SeatOrderDTO {
    numberOfSeats: number;
    seatSelections: SeatSelectionDTO[];
    totalAmount: MoneyDTO;
}


export interface WayPointScheduleDTO {
    location: LocationDTO;
    scheduledAt: string;
    gateName: InternationalStringDTO;
}

/**
 * Represents pick up and drop off point
 */
/* export interface WayPointDTO {
    id: string;
    name: InternationalStringDTO;
}
export interface WayPointOptionDTO {
    wayPoint: WayPointDTO;
    unitFee: MoneyDTO;
}
export interface WayPointSelectionDTO {
    wayPoint: WayPointDTO;
    unitFee: MoneyDTO;
    numberOfSeats: number;
    address: string;
} */

export abstract class WayPointOptionDTO {
    id: string;
    mode: "DOORSTEP" | "FIXED_POINT";
    name: InternationalStringDTO;
    unitFee: MoneyDTO;
    pricingMode?: 'PER_SEAT' | 'PER_STOP';
    description: InternationalStringDTO;
}

export interface PickUpServiceOptionDTO extends WayPointOptionDTO {
    id: string;
    mode: "DOORSTEP" | "FIXED_POINT";
    name: InternationalStringDTO;
    unitFee: MoneyDTO;    
}

export interface DropOffServiceOptionDTO extends WayPointOptionDTO {
    id: string;
    mode: "DOORSTEP" | "FIXED_POINT";
    name: InternationalStringDTO;
    unitFee: MoneyDTO;
}

export interface PickUpOrderLineItemDTO {
    option: PickUpServiceOptionDTO;
    totalFee: MoneyDTO | null;
    numberOfSeats: number;
    address: string;
}

export interface DropOffOrderLineItemDTO {
    option: DropOffServiceOptionDTO;
    totalFee: MoneyDTO | null;
    numberOfSeats: number;
    address: string;
}

export interface PickUpOrderRequestDTO {
    lineItems: PickUpOrderLineItemDTO[];
}

export interface DropOffOrderRequestDTO {
    lineItems: DropOffOrderLineItemDTO[];
}

export interface PickUpOrderDTO {
    lineItems: PickUpOrderLineItemDTO[];
    totalAmount: MoneyDTO;
}
export interface DropOffOrderDTO {
    lineItems: DropOffOrderLineItemDTO[];
    totalAmount: MoneyDTO;
}

export interface TripCustomizationUpdateRequestDTO {
    pickUpOrder?: PickUpOrderRequestDTO;
    dropOffOrder?: DropOffOrderRequestDTO;
}

export interface TripCustomizationCreateRequest extends TripCustomizationUpdateRequestDTO {

    tripId: string;

    seatOrder: SeatOrderRequestDTO;
}

export interface TripCustomizationDTO {
    id: string;

    trip: TripDTO;

    seatOrder: SeatOrderDTO;

    pickUpOrder?: PickUpOrderDTO;

    dropOffOrder?: DropOffOrderDTO;

    createdAt: string;

    expiringAt: string;
}

export interface TentativeBookingCreateRequestDTO {
    tripCustomizationId: string;
    traveller: TravellerDTO;
}

export interface TentativeBookingUpdateRequestDTO {
    traveller: TravellerDTO;
}

export interface TripBookingRequestUpdateDTO {
    traveller: TravellerDTO;
}

export interface TentativeBookingDTO {
    id: string;

    billId: string;

    trip: TripResultDTO;

    seatOrder: SeatOrderDTO;
    pickUpOrder?: PickUpOrderDTO;
    dropOffOrder?: DropOffOrderDTO;
    traveller: TravellerDTO;
    subtotal: MoneyDTO;

    createdAt: string;

    expiringAt: string;
    terms: TermsDTO,
    sseUrl: string
}

export class TermsDTO {
    title: InternationalStringDTO;
    body: InternationalStringDTO;
}

export class PaymentMethodDTO {
    code: string;

    readonly title: string;

    readonly logoUrl: string;

    readonly description?: string;

    terms: InternationalStringDTO;

    constructor(code: string) {
        this.code = code;
    }
}

export class PaymentOptionDTO {
    paymentMethod: PaymentMethodDTO;

    readonly instruction?: string;

    readonly terms: string;

    readonly subtotal: MoneyDTO;

    readonly fees: MoneyDTO;

    readonly total: MoneyDTO;

    readonly paymentUrl: string;

    constructor(paymentMethodCode: string) {
        this.paymentMethod = new PaymentMethodDTO(paymentMethodCode);
    }
}

export interface PromoCodeVerificationRequestDTO {
    billId: string;
    paymentMethodCode: string;
    promoCode: string;
}

export interface PromoCodeVerifiedResponseDTO {
    billId: string;
    paymentOption: PaymentOptionDTO;
    promoCode: string;
    promoCodeVerificationRef: string;
    discountAmount: MoneyDTO;
}

export interface InAppPayParamsDTO {
    merchOrderId: string;
    sign: string;
    orderInfo: string;
    prepayId: string;
}

export interface PaymentIntentCreateRequestDTO {
    billId: string;
    mode: "WEB" | "MINI_APP";
    paymentMethod?: PaymentMethodDTO;
    promoCodeVerificationRef?: string;
}

export interface MiniappPaymentIntentDTO {
    id: string;
    billId: string;
    paymentMethod: PaymentMethodDTO;
    promoCodeVerificationRef?: string;
    miniApp: {
        payParams: InAppPayParamsDTO;
    },
    totalDue: MoneyDTO
}

export interface PaymentIntentDTO {
    id: string;
    billId: string;
    paymentOption: PaymentOptionDTO;
    promoCodeVerificationRef?: string;
    web: {
        payLinkUrl: string;
    };
    paymentToken: string;
}

export interface PaymentTransactionDTO {
    id: string;
    paymentMethod: PaymentMethodDTO;
    transactionRef: string;
    transactionLog: string;
    subtotal: MoneyDTO;
    promoCode: string;
    discountAmount: MoneyDTO;
    fee: MoneyDTO;
    total: MoneyDTO;
    createdAt: string;
}

export interface PaymentSummaryDTO {
    subtotal: MoneyDTO;
    discount: MoneyDTO;
    appliedPromoCode: string;
    fee: MoneyDTO;
    total: MoneyDTO;
}

export interface BookingRequestSummaryDTO {
    id: string;
    trip: TripResultDTO;
    seatOrder: SeatOrderDTO[];
    traveller: TravellerDTO;
    paymentSummary: PaymentSummaryDTO;
    createdAt: string;
}

export interface BookingRequestResultsAggregateDTO {

}

export interface BookingRequestDTO extends BookingRequestSummaryDTO {
    pickUpOrder?: PickUpOrderDTO;
    dropOffOrder?: DropOffOrderDTO;
    totalSeatPrice: MoneyDTO;
    totalPickupFee: MoneyDTO;
    totalDropOffFee: MoneyDTO;
}

export interface BookingSummaryDTO {
    id: string;
    status: "CONFIRMED" | "PROCESSING" | "CANCELLED";
    referenceNumber: string | null;
    trip: TripResultDTO;
    seatOrder: SeatOrderDTO;
    traveller: TravellerDTO;
    paymentSummary: PaymentSummaryDTO;
    createdAt: string;
}


export interface BookingResultSet {
    criteria: {
        offset: number,
        limit: number,
    },
    data: BookingSummaryDTO[]
}

export interface BookingDTO extends BookingSummaryDTO {
    pickUpOrder?: PickUpOrderDTO;
    dropOffOrder?: DropOffOrderDTO;
}

export interface ErrorDTO {
    status: number;
    type: string;
    title: string;
    detail: string;
}


export interface OperatorRatingSummaryDTO {
    totalReviewCount: number;
    averageRating: number;

    seatComfortableness: number;
    cleanliness: number;
    driverBehavior: number;
    staffHelpfulness: number;
    punctuality: number;
}